import React, { useEffect, useRef } from 'react';
import { MdClose } from 'react-icons/md';

import { Slide } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';

import useOnClickOutside from '~/pages/utils/useOnclickOutside';

import OverflowText from '../OverflowText';
import {
  Container,
  Content,
  Header,
  Title,
  Subtitle,
  CloseButton,
  ModalScrollBar,
} from './styles';

interface Props {
  title?: string;
  subtitle?: string;
  description?: string;
  loading?: boolean;
  open: boolean;
  modalState: (opened: boolean) => void;
  size?: 'xs' | 'sm' | 'md' | 'lg';
  disableScrollBar?: boolean;
  disableCloseButton?: boolean;
  enableOutsideClick?: boolean;
  openSlideAnimation?: boolean;
  closeSlideAnimation?: boolean;
  closeButtonAction?: any;
}

const Modal: React.FC<Props> = ({
  title,
  subtitle,
  description,
  loading,
  open,
  modalState,
  size = 'sm',
  children,
  disableScrollBar,
  disableCloseButton,
  enableOutsideClick,
  openSlideAnimation,
  closeSlideAnimation,
  closeButtonAction,
}) => {
  const ref = useRef(null);

  const handleClickOutside = () => {
    if (enableOutsideClick) {
      modalState(false);
    }
  };
  useOnClickOutside(ref, handleClickOutside);

  useEffect(() => {
    if (open) {
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.body.style.overflow = 'unset';
      document.body.style.paddingRight = '0px';
    };
  }, [open]);

  const renderContent = () => {
    return (
      <Content size={size} ref={ref}>
        {!disableCloseButton && (
          <CloseButton
            type="button"
            onClick={() => {
              modalState(false);
              closeButtonAction && closeButtonAction();
            }}
          >
            <MdClose size={25} />
          </CloseButton>
        )}
        {(title || subtitle) && (
          <Header>
            {!loading ? (
              <>
                <OverflowText
                  title={title ?? ''}
                  style={{ marginRight: '30px' }}
                >
                  <Title>{title}</Title>
                </OverflowText>
                {subtitle && <Subtitle>{subtitle}</Subtitle>}
                <p>{description}</p>
              </>
            ) : (
              <>
                <Skeleton animation="wave" width="50%" />
                <Skeleton animation="wave" width="50%" />
                <Skeleton animation="wave" width="50%" />
              </>
            )}
          </Header>
        )}
        {disableScrollBar ? (
          <>{children}</>
        ) : (
          <ModalScrollBar>{children}</ModalScrollBar>
        )}
      </Content>
    );
  };

  return open ? (
    <Container>
      {openSlideAnimation ? (
        <Slide direction="up" in={closeSlideAnimation}>
          {renderContent()}
        </Slide>
      ) : (
        renderContent()
      )}
    </Container>
  ) : null;
};

export default Modal;
